import { cx } from "@emotion/css";
import { LocalAnswers } from "src/components/Exam/Answers/AnswersTypes";
import { LocalOptions } from "src/components/NewComponents/Exam/Option/LocalOptions";
import { useSlot } from "src/components/Slots/SlotsContext";
import { useMark } from "src/hooks/useMark";
import { useQuestionsListSettings } from "src/reducers/questions";
import { ExamStatus, ExamTypes } from "src/types/enums";

import Question from "../../../Exam/QuestionBox/Question";

function QuestionView({
	question,
	setAnswer,
	searchValue,
	disabledSettings,
	className,
	startInEdit = false,
}) {
	const { state } = useQuestionsListSettings();
	const searchTerms = (searchValue || "")
		.split(" ")
		.map((term) => term.trim())
		.filter((term) => term.length > 1);
	const ref = useMark(searchTerms, {
		className: "search-highlight-mark",
	});
	const EditorSlot = useSlot("questionEditor");

	const content = (
		<div ref={ref} className={cx("display-contents")}>
			<Question
				questionDetails={question.details}
				state={state}
				question={question}
				isAnswerSet={false}
			/>
			<LocalAnswers
				question={question}
				setAnswer={setAnswer}
				viewOnly={false}
				examStatus={ExamStatus.ACTIVE}
				examType={ExamTypes.BASIC}
			/>
		</div>
	);

	return (
		<div className={cx("question-view", className)} key={question.id}>
			{EditorSlot ? (
				<EditorSlot
					key={question.id}
					question={question}
					startInEdit={startInEdit}
				>
					{content}
				</EditorSlot>
			) : (
				content
			)}
			{!disabledSettings && <LocalOptions question={question} />}
		</div>
	);
}
export default QuestionView;
